import React from "react";

import { useSelector } from "react-redux";
import styled from "styled-components";

import { selectCustomLeftPanelEnabled } from "Reducers/featureFlags/featureFlags.selectors";

type SplitLayoutProps = {
  children: React.ReactNode;
};

type CustomSplitLayoutProps = {
  customLeftPanel: boolean;
};

const SplitLayout = ({ children }: SplitLayoutProps) => {
  const customLeftPanel = useSelector(selectCustomLeftPanelEnabled);

  return (
    <CustomSplitLayout customLeftPanel={customLeftPanel}>
      {children}
    </CustomSplitLayout>
  );
};

const CustomSplitLayout = styled.div<CustomSplitLayoutProps>`
  display: grid;
  z-index: 3;
  grid-template-columns: minmax(100px, 50%) minmax(100px, 50%);
  padding-left: 0;
  height: 100%;
  max-height: 2000px;

  @media only screen and (min-width: 1680px),
    (max-width: 940px) and (min-width: 600px) {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  @media only screen and (max-width: 940px) {
    grid-template-columns: 100%;
    min-height: unset;
    padding: ${props => (props.customLeftPanel ? null : "24px")};
  }

  @media only screen and (max-width: 940px) and (orientation: landscape) {
    grid-template-columns: 100%;
    min-height: 800px;
  }

  @media only screen and (max-width: 940px) and (min-width: 600px) {
    grid-template-columns: 100%;
    padding: 0 24px;
  }
`;

export default SplitLayout;
